export default __webpack_public_path__ + "static/media/step-7.445d7ebc.webp";